var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { validateParams } from '../_utils/insertSQL';
import { spliceUpdateSQLByConditions } from '../_utils/updateSQL';
export default function (_a) {
    var _this = this;
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val) { return __awaiter(_this, void 0, void 0, function () {
        var isEdit, _i, val_1, item, sql, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isEdit = (_a = env.runtime) === null || _a === void 0 ? void 0 : _a.debug;
                    if (!data.rules) return [3 /*break*/, 7];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!val || !Array.isArray(val) || !val.length) {
                        throw new Error('输入数据错误，非数组或数字为空');
                    }
                    validateParams(val, data.rules.entities[0], data.rules.conAry, false);
                    env.collect('批量更新数据 params: ', val);
                    _i = 0, val_1 = val;
                    _b.label = 2;
                case 2:
                    if (!(_i < val_1.length)) return [3 /*break*/, 5];
                    item = val_1[_i];
                    sql = spliceUpdateSQLByConditions({
                        conditions: data.rules.conditions,
                        connectors: data.rules.conAry,
                        entities: data.rules.entities,
                        params: item,
                        isEdit: isEdit,
                        encrypt: env.encrypt,
                    });
                    env.collect('批量更新数据 sql: ', sql);
                    return [4 /*yield*/, env.executeSql(sql)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    outputs['rtn']();
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _b.sent();
                    isEdit ? console.error('执行SQL发生错误, ', error_1) : undefined;
                    onError("\u6267\u884C\u9519\u8BEF, ".concat(error_1 === null || error_1 === void 0 ? void 0 : error_1.message));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); });
}
